
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post121() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Boa noite pessoal
Quando eu estou nervoso ou com crise de ansiedade, mastigar chiclete me ajuda a acalmar. Sabe de algum que seja indicado pro diabético?</title>
        <meta 
          name="description" 
          content="Boa noite pessoal
Quando eu estou nervoso ou com crise de ansiedade, mastigar chiclete me ajuda a acalmar. Sabe de algum que seja indicado pro diabético?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Tomaz Silveira &#183; 17/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Boa noite pessoal<br/>Quando eu estou nervoso ou com crise de ansiedade, mastigar chiclete me ajuda a acalmar. Sabe de algum que seja indicado pro diabético?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/121')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  4 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Boa noite, Tomaz!<br/><br/>Que bom que você encontrou uma maneira de se acalmar! Mastigar chiclete pode realmente ajudar a relaxar, mas é importante escolher um que não prejudique sua saúde.<br/><br/>Para diabéticos, os chicletes sem açúcar são a melhor opção. Eles ajudam a evitar picos de glicose no sangue. Dá uma olhada nos rótulos e procure por chicletes adoçados com adoçantes como xilitol, sorbitol ou aspartame, que são mais seguros para quem tem diabetes.<br/><br/>Lembre-se sempre de confirmar com o seu médico ou nutricionista antes de adicionar algo novo na sua rotina, ok? Eles conhecem melhor o seu caso e podem dar orientações mais específicas.<br/><br/>Qualquer coisa, estamos por aqui para te ajudar!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 17/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/121')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Mariana Silva &#183; 12/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/78-colesterol" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. O médico me receitou sinvastatina 20 mg uma vez por dia.<br/>Será que estou tão mal assim fico preocupada??<br/>Meu exame deu isso<br/>HDL 78.5<br/>NAO-Hdl 180mg<br/>Colesterol total 258.3<br/>Ldl 164<br/>Triglicerides 77<br/>Hemoglobina glicada 4.9%<br/><br/>Obrigado!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/78')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/9-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Sobre perda e controle do peso  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Controlar meu peso foi a primeira coisa onde foquei depois do meu diagnóstico com colesterol alto. Eu estava com obesidade, e precisava reduzir meu peso de maneira sustentável e saudável. Com isso em mente, estudei e apliquei o que aprendi. <br/><br/>Algumas coisas que não sabia, mas que me aproximaram da realidade, são que pessoas que estão acima do seu peso ideal tem:<br/><br/>1) Maior risco de tornarem-se diabéticos.<br/>2) Maior risco de tornarem-se hipertensos.<br/>3) Maior risco de câncer de mama.<br/>4) Maior risco de câncer de cólon.<br/>5) Existe uma correlação direta entre sobrepeso e doenças cardíacas.<br/><br/>Com conhecimento sobre esses pontos comecei a trabalhar em desenvolver uma alimentação que me permitisse perder peso, e sustentar meu novo peso saudável. Notem aqui algo super importante, que nem sempre é evidente: a sua dieta para perda de peso precisa ser a sua nova rotina de alimentação como um todo, e não algo que você vai fazer algumas semanas enquanto perde peso, e depois vai parar e voltar para o que era antes. Se isso acontecer, todo o peso que você perdeu vai voltar em pouco tempo e com alguns kilos a mais.<br/><br/>PONTO CHAVE: A dieta de perda de peso precisa se tornar a nova rotina de alimentação como um todo.<br/><br/>Então, o ponto chave é: sua alimentação para perda de peso precisa ser sua alimentação para sustentar aquele peso. Ou seja, precisa ser sua nova educação alimentar, seu novo e permanente estilo de vida para alimentação.<br/><br/>Para montar seu novo estilo de vida alimentar é legal ter a ajuda de um nutricionista que te conhece. Mas alguns pontos gerais que eu usei e podem ser úteis:<br/><br/>O número de calorias que você consome menos o número de calorias que você queima determina se você irá ganhar ou perder peso. É importante focar em comidas que irão te dar a sensação de estar cheio/satisfeito com o menor número de calorias: comidas ricas em fibra, frutas e vegetais são ótimas opções, e devem fazer parte integral da nova alimentação (foque em no mínimo 3 frutas por dia!).<br/><br/>Corte os lanches durante o dia e a sobremesa enquanto você estiver tentando perder peso. E após ter chegado no seu peso ideal, esses lanches devem ser frutas.<br/><br/>Cuidado com o tamanho das porções. Mas coma quantos vegetais e frutas quiser, esses são livres!<br/><br/>Evite frituras. Elas adicionam cerca de um terço a mais de calorias. Prefira grelhados ou assados.<br/><br/>Faça exercícios: suas chances de perder peso e manter o peso ideal são muito melhores se você se exercitar. Até mesmo uma caminhada algumas vezes por dia é 1000 vezes melhor do que ficar sentado na frente da TV.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/9')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Vitoria Novaes &#183; 21/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/139-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Microlitiase vesícula   
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Olá, <br/>tenho cerca de 4 pedras na vesícula com tamanho menor que 1 milímetro. O médico indicou cirurgia é realmente necessário? <br/><br/><br/>Eu sinto dores no estômago após refeições pesadas e gordurosas, mas eu também tenho uma gastrite!!! 
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/139')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            7 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marília Dornelles &#183; 20/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/134-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Gente me tirem uma dúvida: É verdade que quando a gente usa insulina uma vez , é para sempre?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/134')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            6 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Fernanda Salles &#183; 23/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/149-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde, pessoal!<br/>O que fazer pra aumentar as plaquetas?<br/>A minha irmã está em tratamento paliativo faz mais de um ano, e não está conseguindo aumentar as plaquetas de jeito nenhum, e ela precisa disso para poder tomar os remédios da quimioterapia.<br/>Ela já recebeu transfusão de sangue, está tomando ferro há quatro dias, comendo feijão, beterraba e bebendo água de coco, mas sem resultados.<br/>Alguma ideia?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/149')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
